<template>
  <div class="ship-sec" :style="isMenuOpen ? 'bottom: 51%' : 'bottom: 20px'">
    <button @click="toggleMenu" class="menu-button">
      <i class="ri-arrow-up-double-fill" :style="isMenuOpen ? 'transform: rotate(180deg)' : ''"></i>
    </button>
    <div class="ship-menu" v-if="isMenuOpen">
      <div class="menu-search-container">
        <div class="menu-search rounded-pill">
          <i class="ri-search-line mr-2"></i>
          <input v-model="searchQuery" type="text" class="transparent-input mb-1" placeholder="Search Asset Name..." @focus="focusInput">
        </div>
        <div class="menu-controls ml-2">
          <button class="btn btn-sm btn-mantraz" @click="showAll">Show All</button>
          <button class="btn btn-sm btn-outline-mantraz ml-1" @click="hideAll">Hide All</button>
        </div>
      </div>
      <div class="menu-content row">
        <div class="col-md-6" v-for="item in filteredShips" :key="item.id">
          <div class="menu-card">
            <div class="row">
              <div class="col-8 d-flex align-items-center pr-0">
                <h6 @click="zoomToShip(item)" style="cursor: pointer">{{ item.massName }}</h6>
              </div>
              <div class="col-4 d-flex justify-content-end align-items-center pt-0">
                <h6 :class="[item.dataStatus ? 'status online' : 'status offline']">{{ item.dataStatus ? 'online' : 'offline' }}</h6>
                <span class="ml-2 change-section" @click="toggleSection(item)" style="cursor: pointer">
                  <i class="ri-arrow-drop-right-line" style="font-size: 23px;"></i>
                </span>
              </div>
            </div>
            <div class="row info-section" v-if="item.isSectionOpen">
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <b-form-checkbox v-model="item.trail" name="check-button" switch class="mr-2"
                  @change="updateTrail({massId: item.massId, trail: item.trail})"></b-form-checkbox>
                  <p>Vessel Trail</p>
                </div>
                <div class="d-flex align-items-center mt-2">
                  <b-form-checkbox v-model="item.isVisible" name="check-button-visible" switch class="mr-2"
                  @change="updateVisibility({massId: item.massId, isVisible: item.isVisible})"></b-form-checkbox>
                  <p>Show Ship</p>
                </div>
              </div>
            </div>
            <div class="row info-section" v-else>
              <div class="col-md-6 col-sm-12 p-0">
                <p style="font-size: 12px;">Coordinates</p>
                <p style="font-weight: 500; color: #1E1E1E;">{{ item?.lastCoordinate || '-' }}</p>
              </div>
              <div class="col-md-6 col-sm-12 p-0">
                <p style="font-size: 12px;">Current Speed</p>
                <p style="font-weight: 500; color: #1E1E1E;">
                {{ item.lastGpsData &&
                  item.lastGpsData.speed &&
                  (item.lastGpsData.speed * 0.539957).toFixed(2) || '-'
                }} NM</p>
              </div>
              <div class="col-md-6 col-sm-12 p-0">
                <p style="font-size: 12px;">Port RPM</p>
                <p style="font-weight: 500; color: #1E1E1E;">
                  {{
                    item.lastRpmData &&
                    item.lastRpmData.find((rpm) => rpm.type === 'PORT') &&
                    item.lastRpmData.find((rpm) => rpm.type === 'PORT').rpm
                  }}
                  RPM</p>
              </div>
              <div class="col-md-6 col-sm-12 p-0">
                <p style="font-size: 12px;">Starboard RPM</p>
                <p style="font-weight: 500; color: #1E1E1E;">{{
                    item.lastRpmData &&
                    item.lastRpmData.find((rpm) => rpm.type === 'STARBOARD') &&
                    item.lastRpmData.find((rpm) => rpm.type === 'STARBOARD').rpm
                  }}
                  RPM</p>
              </div>
            </div>
            <div class="row button-section">
              <div class="col-md-6 col-sm-12 py-0 pl-0">
                <button class="btn btn-mantraz btn-block tooltip-button mr-1" style="font-size: 14px" @click="() => handleClickReport(item.massId)">Report</button>
              </div>
              <div class="col-md-6 col-sm-12 py-0 pl-0">
                <button class="btn btn-outline-mantraz btn-block tooltip-button" style="font-size: 14px" @click="() => handleClickDashboard(item.massId)">Dashboard</button>
              </div>
              <div class="col-md-6 col-sm-12 py-0 pl-0">
                <button class="btn btn-mantraz btn-block tooltip-button mr-1" style="font-size: 14px" @click="zoomToShip(item)">Zoom to Ship</button>
              </div>
              <div class="col-md-6 col-sm-12 py-0 pl-0">
                <button class="btn btn-outline-mantraz btn-block tooltip-button" style="font-size: 14px" @click="handleClickVoyage(item.massId)">Voyage Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShipSection',
  props: {
    ships: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isMenuOpen: false,
      isInputFocused: false,
      selectedId: null,
      searchQuery: '',
      localShips: [],
    };
  },
  computed: {
    filteredShips() {
      if (!this.searchQuery) {
        return this.localShips;
      }
      const searchRegex = new RegExp(this.searchQuery, 'i');
      return this.localShips.filter((ship) => searchRegex.test(ship.massName));
    },
  },
  watch: {
    ships: {
      handler(newShips) {
        this.localShips = newShips.map((newShip) => {
          const existingShip = this.localShips.find(
            (local) => local.massId === newShip.massId,
          );
          return {
            ...newShip,
            isSectionOpen: existingShip ? existingShip.isSectionOpen : false,
            isVisible: newShip.isVisible !== undefined ? newShip.isVisible : true,
          };
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async handleClickDashboard(massId) {
      this.$store.dispatch('filter/setCurrentMassId', massId);
      await this.$router.push({ name: 'FmsDashboard' });
    },
    async handleClickReport(massId) {
      this.$store.dispatch('filter/setCurrentMassId', massId);
      await this.$router.push({ name: 'FmsReport' });
    },
    async handleClickVoyage(massId) {
      this.$store.dispatch('filter/setCurrentMassId', massId);
      await this.$router.push({ name: 'FmsVoyageReport' });
    },
    formatUnixTimestamp(unixTime) {
      const date = new Date(unixTime * 1000);
      const day = `0${date.getDate()}`.slice(-2);
      const month = `0${date.getMonth() + 1}`.slice(-2);
      const year = date.getFullYear();
      const hour = `0${date.getHours()}`.slice(-2);
      const minutes = `0${date.getMinutes()}`.slice(-2);

      return `${day}-${month}-${year} ${hour}:${minutes}`;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleSection(shipToToggle) {
      // Metode ini sekarang aman karena state tidak akan di-reset oleh watch
      shipToToggle.isSectionOpen = !shipToToggle.isSectionOpen;
    },
    focusInput() {
      this.isInputFocused = true;
    },
    updateTrail({ massId, trail }) {
      this.isMenuOpen = false;
      this.$emit('toggle-trail', { massId, trail });
    },
    showAll() {
      this.$emit('show-all-ships');
    },
    hideAll() {
      this.$emit('hide-all-ships');
    },
    updateVisibility({ massId, isVisible }) {
      this.$emit('toggle-visibility', { massId, isVisible });
    },
    zoomToShip(item) {
      this.isMenuOpen = false;
      this.$emit('zoom-to-ship', item);
    },
  },
};
</script>

<style scoped>
.ship-sec {
  position: fixed;
  width: 100%;
  z-index: 999;
}

.ship-sec .menu-button {
  background-color: white;
  color: #264284;
  border: none;
  padding: 0px 100px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  transition: transform 0.3s ease-in-out;
}

.ship-sec button i {
  font-size: 20px;
}

.ship-menu {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50vh;
  width: 100%;
  background-color: rgba(255, 239, 239, 0.737);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow-y: scroll;
  z-index: 999;
}

.menu-search-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  width: 60%; /* Lebarkan container */
  margin: 0 auto;
}

.menu-search {
  padding: 10px;
  width: 65%; /* Sesuaikan lebar search bar */
  display: flex;
  align-items: center;
  height: 35px;
  background-color: #ebebeb;
}

.menu-controls {
    display: flex;
    align-items: center;
}

@media (max-width: 768px) {
  .menu-search-container {
    width: 95%;
  }
  .menu-search {
    width: 60%;
  }
}

.menu-search .transparent-input {
  background-color: transparent;
  border: none;
  width: 100%;
  padding: 5px;
  margin-left: 10px;
}

.menu-search .transparent-input:focus {
  outline: 0;
}

.menu-search input::placeholder {
  color: #202224;
}

.menu-content {
  padding: 10px;
  height: calc(100% - 70px);
  overflow-y: scroll;
  width: 50%;
  margin: 0 auto;
}

.menu-card {
  background-color: #fff;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
  border-color: #E8ECF3;
  padding: 15px 16px;
  min-height: 201px;
}

.col-md-6 {
  padding-right: 10px;
}

.status {
  margin-left: 10px;
  padding: 1px 5px;
  border-radius: 5px;
  font-weight: 600;
}

.online {
  background-color: #D7F0D8;
  color: #38AC3D;
}

.offline {
  background-color: #FFE4E4;

  color: #F24848;
}

.card-button {
  width: 100%;
  font-weight: 700;
}

.col-md-3 {
  padding: 0 !important;
}

.info-section {
  padding: 0 15px 10px 15px;
  min-height: 71.6px;
}

.button-section {
  padding: 0 15px 15px 15px;
}

.button-section button {
  margin-bottom: 10px;
}

p {
  margin-bottom: -2px !important;
}

@media (min-width: 768px) {
  .menu-content {
    width: 70%;
  }
}

@media (max-width: 480px) {
  .menu-content {
    width: 100%;
  }
  .menu-search {
    width: 80%;
  }
}
</style>
